
import { SiteSettings } from './SiteSettings';

export const GeneralSettings = () => {
  return <SiteSettings />;
};
